/* eslint-disable */
export default {
  loading: 'A carregar…',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
